/** Shared DGA validation — source of truth is @porchpass/ui */
export {
  emailSchema,
  phoneSchema,
  nameSchema,
  suffixSchema,
  draftReadinessSchema,
  draftCreationFormSchema,
  validatePersonalInfoField,
  validateNearestRelativeField,
  ssnSchema,
  validateDobAge,
  validateBankruptcyDate,
  validateDependentsAges,
  validateDirtyPersonalInfoFields,
  zipCodeSchema,
  validateAddressField,
  validateAddressFields,
  mailingAddressSubmitSchema,
  previousAddressSubmitSchema,
  addressSubmitSchema,
  maritalInfoSubmitSchema,
  piiSubmitSchema,
  personalInfoSubmitSchema,
  validateEmploymentField,
  employmentSubmitSchema,
  validateEmploymentForSubmit,
  validateFinancialAccountField,
  financialAccountSubmitSchema,
  validateAdditionalIncomeField,
  additionalIncomeSubmitSchema,
  validateExpenseField,
  expenseSubmitSchema,
  validateHomeField,
  validateDirtyHomeFields,
  homeSubmitSchema,
  pricingSubmitSchema,
  validateLandField,
  validateLandForSubmit,
} from "@porchpass/ui";
